import React, { useCallback, useEffect, useState } from "react";
import { PreParsedEvent, useAppContext } from "./AppContext";
import  * as EventFilters from "./EventFilters";

import WeekBars from "./dashboard_elements/WeekBars";
import RoundedContainer from "./layouts/RoundedContainer";
import Alert from "./components/Alert";

export type clinicWeekData = {
    weekNumber?: number,
    openAppointmentCount: number,
    bookedAppointmentCount: number
    roundsCount: number
}

export default function Dashboard(props: any){
    const app = useAppContext();
    useEffect(() => {
        document.title = "My Clinic Schedule: Dashboard"
     }, []);
    const [openApptCount, setOpenApptCount] = useState<number | undefined>(undefined)
    const [bookedApptCount, setBookedApptCount] = useState<number | undefined>(undefined)
    const [roundsCount, setRoundsCount] = useState<number | undefined>(undefined)

   
    const countImportantItems = useCallback((events: PreParsedEvent[], returnArray = false): clinicWeekData => {
        const openAppointmentCount = new EventFilters.EventFilters(events).Free().events.length
        const bookedAppointmentCount = events.filter((x)=>EventFilters.is_appointment(x)).length
        const roundsCount = events.filter((x)=>EventFilters.is_rounds(x)).length

        return {
            openAppointmentCount : openAppointmentCount,
            bookedAppointmentCount: bookedAppointmentCount,
            roundsCount: roundsCount
        }
    },[])

    useEffect(() => {
    
        if(app.events){
            let results = countImportantItems(app.events)
            setOpenApptCount(results.openAppointmentCount)
            setBookedApptCount(results.bookedAppointmentCount)
            setRoundsCount(results.roundsCount)
        }
    }, [app.events,countImportantItems])


    return(
        <React.Fragment>
        <RoundedContainer title="Personal Metrics" subheading="Get a sense of how you are filling your chair time">
            <div>

            <h6>Future</h6>
            <WeekBars
            startWeekDelta={0} 
            endWeekDelta={8}/>
            <br></br>

            <h6>Historical</h6>
            <WeekBars
            startWeekDelta={undefined} 
            endWeekDelta={0}/>
            

            <h6>All</h6>
            <WeekBars
            startWeekDelta={undefined} 
            endWeekDelta={undefined}/>
            <br></br>
            
            <p>Booked appointment blocks: {bookedApptCount} </p>
            <p>Open appointment blocks : {openApptCount} </p>
            <p>Rounds events : {roundsCount}</p>
            </div>
            <br></br>

            <Alert variant="gray">
                Check back soon for more metrics...
            </Alert>
        </RoundedContainer>
        </React.Fragment>
    )
}


